
import { Card, Table, Form, Row, Col } from "react-bootstrap";
import { FiEdit, FiTrash } from "react-icons/fi";
import DeleteStudentModal from "../../components/modals/recruitment/campushiring/DeleteStudentModal";
import EditStudentModal from "../../components/modals/recruitment/campushiring/EditStudentModal";
import CampusHiringHeader from "../../components/recruitment/CampusHiringHeader";
import { FiCalendar, FiChevronDown } from "react-icons/fi";
import React, { useState, useRef, useEffect } from "react";
import {  Dropdown } from "react-bootstrap";
const initialData = [
  {
    id: 1,
    name: "Harold Gaynor",
    img: "/assets/img/users/user-01.jpg",
    branch: "B.E/CSE",
    year: "2025",
    role: "Accountant",
    recruiter: "Anthony Lewis",
    recruiterImg: "/assets/img/users/user-02.jpg",
    status: "Applied",
  },
  {
    id: 2,
    name: "Sandra Ornellas",
    img: "/assets/img/users/user-03.jpg",
    branch: "B.Tech/IT",
    year: "2025",
    role: "App Developer",
    recruiter: "Brian Villalobos",
    recruiterImg: "/assets/img/users/user-04.jpg",
    status: "Shortlisted",
  },
  {
    id: 3,
    name: "John Harris",
    img: "/assets/img/users/user-05.jpg",
    branch: "B.E/CSE",
    year: "2025",
    role: "Technician",
    recruiter: "Harvey Smith",
    recruiterImg: "/assets/img/users/user-06.jpg",
    status: "In progress",
  },
  {
    id: 4,
    name: "Whitney Barnette",
    img: "/assets/img/users/user-07.jpg",
    branch: "B.E/CSE",
    year: "2025",
    role: "Web Developer",
    recruiter: "Stephan Peralt",
    recruiterImg: "/assets/img/users/user-08.jpg",
    status: "Applied",
  },
  {
    id: 5,
    name: "Richard Thompson",
    img: "/assets/img/users/user-09.jpg",
    branch: "B.E/CSE",
    year: "2024",
    role: "Sales Executive Officer",
    recruiter: "Doglas Martini",
    recruiterImg: "/assets/img/users/user-10.jpg",
    status: "Selected",
  },
  {
    id: 6,
    name: "Kerry Drake",
    img: "/assets/img/users/user-11.jpg",
    branch: "B.Tech/IT",
    year: "2025",
    role: "Designer",
    recruiter: "Linda Ray",
    recruiterImg: "/assets/img/users/user-12.jpg",
    status: "Rejected",
  },
  {
    id: 7,
    name: "David Carmona",
    img: "/assets/img/users/user-13.jpg",
    branch: "B.E/EEE",
    year: "2025",
    role: "Account Manager",
    recruiter: "Elliot Murray",
    recruiterImg: "/assets/img/users/user-14.jpg",
    status: "Shortlisted",
  },
  {
    id: 8,
    name: "Margaret Soto",
    img: "/assets/img/users/user-15.jpg",
    branch: "B.Tech/IT",
    year: "2025",
    role: "SEO Analyst",
    recruiter: "Rebecca Smith",
    recruiterImg: "/assets/img/users/user-16.jpg",
    status: "Selected",
  },
  {
    id: 9,
    name: "Jeffrey Thaler",
    img: "/assets/img/users/user-17.jpg",
    branch: "BBA",
    year: "2024",
    role: "Admin",
    recruiter: "Connie Waters",
    recruiterImg: "/assets/img/users/user-18.jpg",
    status: "Applied",
  },
  {
    id: 10,
    name: "Lori Broaddus",
    img: "/assets/img/users/user-19.jpg",
    branch: "MBA",
    year: "2025",
    role: "Business Analyst",
    recruiter: "Daniel Carter",
    recruiterImg: "/assets/img/users/user-20.jpg",
    status: "Selected",
  },
];

export default function CampusHiringPage() {
  const [data, setData] = useState(initialData);
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState(10);
  const [selected, setSelected] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const filtered = data
    .filter((d) =>
      d.name.toLowerCase().includes(search.toLowerCase())
    )
    .slice(0, rows);

  const getStatusStyle = (status) => {
    switch (status) {
      case "Applied":
        return { background: "#f3e8ff", color: "#9333ea" };
      case "Shortlisted":
        return { background: "#ffe4e6", color: "#e11d48" };
      case "In progress":
        return { background: "#dbeafe", color: "#2563eb" };
      case "Selected":
        return { background: "#dcfce7", color: "#16a34a" };
      case "Rejected":
        return { background: "#fee2e2", color: "#dc2626" };
      default:
        return {};
    }
  };
  const [role, setRole] = useState("Role");
  const [status, setStatus] = useState("Select Status");
  const [sort, setSort] = useState("Sort By : Last 7 Days");

 const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeRange, setActiveRange] = useState("Last 7 Days");
  const containerRef = useRef();

  const rangeOptions = [
    "Today",
    "Yesterday",
    "Last 7 Days",
    "Last 30 Days",
    "This Year",
    "Next Year",
    "Custom Range"
  ];

  // close dropdown
  useEffect(() => {
    const handleOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("click", handleOutside);
    return () => document.removeEventListener("click", handleOutside);
  }, []);

  // format date
  const formatDateValue = (date) =>
    date.toLocaleDateString("en-GB");

  // generate date range text
  const generateRangeLabel = () => {
    const today = new Date();
    let start = new Date();

    switch (activeRange) {
      case "Today":
        return `${formatDateValue(today)} - ${formatDateValue(today)}`;

      case "Yesterday":
        start.setDate(today.getDate() - 1);
        return `${formatDateValue(start)} - ${formatDateValue(start)}`;

      case "Last 7 Days":
        start.setDate(today.getDate() - 7);
        return `${formatDateValue(start)} - ${formatDateValue(today)}`;

      case "Last 30 Days":
        start.setDate(today.getDate() - 30);
        return `${formatDateValue(start)} - ${formatDateValue(today)}`;

      case "This Year":
        start = new Date(today.getFullYear(), 0, 1);
        return `${formatDateValue(start)} - ${formatDateValue(today)}`;

      case "Next Year":
        const nextStart = new Date(today.getFullYear() + 1, 0, 1);
        const nextEnd = new Date(today.getFullYear() + 1, 11, 31);
        return `${formatDateValue(nextStart)} - ${formatDateValue(nextEnd)}`;

      default:
        return "Custom Range";
    }
  };

  // select handler
  const handleRangeChange = (item) => {
    setActiveRange(item);
    setIsMenuOpen(false);
  };


  
  return (
<div  style={{ padding: "15px", background: "#f8f9fa",  }} >
<CampusHiringHeader/>

    <Card style={{ borderRadius: 10 }}>
      <Card.Header
      style={{
        background: "#fff",
        borderBottom: "1px solid #eee",
        padding: "15px 20px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 10,
        }}
      >
        {/* TITLE */}
        <div
          style={{
            fontWeight: 600,
            fontSize: 17,
            position: "relative",
          //   display: "inline-block",
          }}
        >
          Students List
          {/* <div
            style={{
              position: "absolute",
              bottom: -4,
              left: 0,
              width: "100%",
              height: 4,
              background: "#f97316",
              borderRadius: 2,
            }}
          /> */}
        </div>

        {/* FILTERS */}
        <div
          style={{
            display: "flex",
            gap: 10,
            flexWrap: "wrap",
          }}
        >
          {/* DATE */}
         <div ref={containerRef} style={{ position: "relative", width: 250 }}>

      {/* TOP INPUT */}
      <div
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        style={{
          border: "1px solid #e5e7eb",
          padding: "10px 12px",
          borderRadius: 8,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          background: "#fff",
          fontSize: 14
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <FiCalendar />
          {generateRangeLabel()}
        </div>
        <FiChevronDown />
      </div>

      {/* DROPDOWN LIST */}
      {isMenuOpen && (
        <div
          style={{
            position: "absolute",
            top: "105%",
            left: 0,
            width: "100%",
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: 10,
            padding: "8px 0",
            zIndex: 1000
          }}
        >
          {rangeOptions.map((item, idx) => (
            <div
              key={idx}
              onClick={() => handleRangeChange(item)}
              style={{
                padding: "12px 16px",
                fontSize: 14,
                cursor: "pointer",
                background:
                  activeRange === item ? "#ff6b00" : "transparent",
                color:
                  activeRange === item ? "#fff" : "#111827"
              }}
              onMouseEnter={(e) => {
                if (activeRange !== item)
                  e.currentTarget.style.background = "#f3f4f6";
              }}
              onMouseLeave={(e) => {
                if (activeRange !== item)
                  e.currentTarget.style.background = "transparent";
              }}
            >
              {item}
            </div>
          ))}
        </div>
      )}

      {/* MOBILE */}
      <style>
        {`
          @media (max-width: 1024px) {
            div[style] {
              width: 100% !important;
              margin-top: 10px !important;
            }
          }
        `}
      </style>
    </div>


          {/* ROLE */}
          <Dropdown>
            <Dropdown.Toggle style={btnStyle}>
              {role}
            </Dropdown.Toggle>

            <Dropdown.Menu style={menuStyle}>
              {["Developer", "Designer", "HR", "Manager"].map((item) => (
                <Dropdown.Item
                  key={item}
                  onClick={() => setRole(item)}
                  style={itemStyle}
                >
                  {item}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>

          {/* STATUS */}
          <Dropdown>
            <Dropdown.Toggle style={btnStyle}>
              {status}
            </Dropdown.Toggle>

            <Dropdown.Menu style={menuStyle}>
              {["Applied", "Shortlisted", "Selected", "Rejected"].map((item) => (
                <Dropdown.Item
                  key={item}
                  onClick={() => setStatus(item)}
                  style={itemStyle}
                >
                  {item}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>

          {/* SORT */}
          <Dropdown>
            <Dropdown.Toggle style={btnStyle}>
              {sort}
            </Dropdown.Toggle>

            <Dropdown.Menu style={menuStyle}>
              {[
                "Today",
                "Last 7 Days",
                "Last 30 Days",
                "This Year",
              ].map((item) => (
                <Dropdown.Item
                  key={item}
                  onClick={() => setSort(`Sort By : ${item}`)}
                  style={itemStyle}
                >
                  {item}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </Card.Header>

      <Card.Body>
        {/* FILTER */}
        <Row className="mb-3">
          <Col md={6}>
            Row Per Page{" "}
            <Form.Select
              value={rows}
              onChange={(e) => setRows(Number(e.target.value))}
              style={{ width: 80, display: "inline-block" }}
            >
              <option>5</option>
              <option>10</option>
              <option>20</option>
            </Form.Select>{" "}
            Entries
          </Col>

          <Col md={6} className="text-md-end">
            <Form.Control
              placeholder="Search"
              style={{ maxWidth: 250, display: "inline-block" }}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>
        </Row>

        {/* TABLE */}
        <div className="table-responsive">
          <Table hover>
            <thead style={{ background: "#f8fafc" }}>
              <tr>
                <th><Form.Check /></th>
                <th>Student Name</th>
                <th>Branch</th>
                <th>Graduation Year</th>
                <th>Job Role</th>
                <th>Recruiter Name</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {filtered.map((item) => (
                <tr key={item.id}>
                  <td><Form.Check /></td>

                  <td>
                    <div style={flexRow}>
                      <img src={item.img} style={avatar} />
                      <div>
                        <div>{item.name}</div>
                        <small>[email protected]</small>
                      </div>
                    </div>
                  </td>

                  <td>{item.branch}</td>
                  <td>{item.year}</td>
                  <td>{item.role}</td>

                  <td>
                    <div style={flexRow}>
                      <img src={item.recruiterImg} style={avatar} />
                      {item.recruiter}
                    </div>
                  </td>

                  <td>
                    <span style={{ ...badge, ...getStatusStyle(item.status) }}>
                      ● {item.status}
                    </span>
                  </td>

                  <td>
                    <div style={{ display: "flex", gap: 10 }}>
                      <FiEdit
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setSelected(item);
                          setShowEdit(true);
                        }}
                      />
                      <FiTrash
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setSelected(item);
                          setShowDelete(true);
                        }}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card.Body>

      {/* MODALS */}
      <EditStudentModal
        show={showEdit}
        onHide={() => setShowEdit(false)}
        data={selected}
        onSave={(updated) => {
          setData(data.map(d => d.id === updated.id ? updated : d));
        }}
      />

      <DeleteStudentModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onDelete={() => {
          setData(data.filter(d => d.id !== selected.id));
          setShowDelete(false);
        }}
      />
    </Card>

</div>


  );
}

/* STYLES */
const flexRow = { display: "flex", alignItems: "center", gap: 10 };
const avatar = { width: 35, height: 35, borderRadius: "50%" };
const badge = {
  padding: "4px 10px",
  borderRadius: 6,
  fontSize: 12,
};
const btnStyle = {
  background: "#fff",
  border: "1px solid #e5e7eb",
  borderRadius: 8,
  padding: "9px 12px",
  fontSize: 15,
  color: "#111",
  minWidth: 100,
};

const menuStyle = {
  borderRadius: 10,
  padding: "8px 0",
  minWidth: 180,
  boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
  border: "1px solid #eee",
};

const itemStyle = {
  padding: "8px 15px",
  fontSize: 14,
};